const namespaced = true;

const defaultState = () => {
  return {
    companies: [],
    isAddCompany: false,
    packages: [],
    cities: [],
    countries: [],
    confirm: false,
    selectedCompany: {},
    edit: false,
    loading: true,
    setAdventResourceDialog: {
      show: false,
      company: null,
    },
    setFmhTokenDialog: {
      show: false,
      company: null,
    }
  };
};

const state = defaultState()
const actions = {};
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_UPDATE_COMPANY(state, company) {
    const index = state.companies.map((item) => item.id).indexOf(company.id);
    state.companies.splice(index, 1, company);
  },
  SET_SELECTED_COMPANY(state, selectedCompany) {
    state.selectedCompany = selectedCompany;
  },
  SET_CONFIRM(state, confirm) {
    state.confirm = confirm;
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  },
  SET_COMPANY_COUNTRIES(state, countries) {
    state.countries = countries;
  },
  SET_USER_COMPANIES(state, companies) {
    state.companies = companies;
  },
  SET_IS_ADD_COMPANY(state, isAddCompany) {
    state.isAddCompany = isAddCompany;
  },
  SET_COMPANY_PACKAGES(state, packages) {
    state.packages = packages;
  },
  SET_COMPANY_CITIES(state, cities) {
    state.cities = cities;
  },
  ADD_COMPANY_TO_USER(state, company) {
    state.companies = [...state.companies, company];
  },
  DELETE_COMPANY(state, id) {
    const removeIndex = state.companies.map((item) => item.id).indexOf(id);
    state.companies.splice(removeIndex, 1);
  },
  SET_ADVENT_RESOURCE_DIALOG(state, setAdventResourceDialog) {
    state.setAdventResourceDialog = setAdventResourceDialog;
  },
  SET_FMH_TOKEN_DIALOG(state, setFmhTokenDialog) {
    state.setFmhTokenDialog = setFmhTokenDialog;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
